import React from 'react';

const Header = () => (
	<>
		<header id='header'>
			<div className='container-fluid'>
				<div id='logo' className='pull-left'>
					<h1>
						<a href='#intro' className='scrollto'>
							Aluzinc
						</a>
					</h1>

					<a href='#intro'>
						<img src='componentsScripts/img/logo.png' alt='' title='' />
					</a>
				</div>

				<nav id='nav-menu-container'>
					<ul className='nav-menu'>
						<li className='menu-active'>
							<a href='#intro'>Home</a>
						</li>
						<li>
							<a href='#about'>About Us</a>
						</li>

						<li>
							<a href='#portfolio'>Our Products</a>
						</li>

						<li>
							<a href='#contact'>Contact</a>
						</li>
					</ul>
				</nav>
			</div>
			<nav id='mobile-nav-menu-container'>
				<ul class='mobile-nav-menu'>
					<li class='mobile-menu-active'>
						<a href='#mobile-intro'>Home</a>
					</li>
					<li>
						<a href='#mobile-about'>About Us</a>
					</li>
					<li>
						<a href='#mobile-services'>Services</a>
					</li>
					<li>
						<a href='#mobile-portfolio'>Portfolio</a>
					</li>
					<li>
						<a href='#mobile-team'>Team</a>
					</li>

					<li>
						<a href='#mobile-contact'>Contact</a>
					</li>
				</ul>
			</nav>
		</header>
	</>
);

export default Header;
